export default {
  title: 'Detalhes do código promocional',
  back: 'Voltar aos códigos promocionais',
  tabs: {
    customers: 'Clientes',
    orders: 'Encomendas',
  },
  metrics: {
    gmv: 'GMV',
    average_order_value: 'Valor médio de encomenda',
    customer_adoption: 'Clientes únicos',
  },
  toasts: {
    failed_to_load_stats: 'Falha ao carregar as estatísticas',
  },
};
